<template>
  <div>

    <h1>{{ focused.title }}</h1>
    <img class="card" :src="`/static/images/${focused.id}.png`" v-if="focused.image && focused.title != 'Performance | Theory'" width="300px">
    <div id="overview"><vue-markdown :source="focused.overview" /> <p v-if="focused.contributor" style="text-align:right; font-style:italic">—{{focused.contributor}}</p></div>
    <div :key="category" v-for="(items, category) in links">
      <h3>{{ category }}s</h3>
      <div v-if="category=='Work'" class="card-row">
        <!-- Each work on a card of its own -->
        <div v-for="item in items" :key="item.id">
          <router-link :to="'/'+item.id" class="card"
            :style="{'background': 'url(/static/images/'+item.id+'.png)', 'background-size': '100% 100%', 'height': '190px', 'width': '125px', 'display':'block'}"></router-link>
        </div>
      </div>

      <div v-else-if="category=='Author'" class="card-row">
        <div v-for="item in items" :key="item.id">
          <router-link :to="'/'+item.id" class="card"
            :style="{'background': 'url(/static/images/'+item.id+'.png)', 'background-size': 'cover', 'height': '200px', 'width': '200px', 'display': 'block'}">
            <div style="display: block; width: 100%; height: 160px;"></div>
            <div style="padding-left: 20px; margin-left: -10px; border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; width: 200px; height: 50px; line-height: 50px; display: block; background-color: rgba(0, 0, 0, 0.2); color: #F6EDD9; font-weight: bold; font-size: 1rem;">{{item.title}}</div>
            </router-link>
        </div>
      </div>
      <div v-else-if="category=='Link'">
        <ul>
          <li :key="item.id" v-for="item in items">
            <a :href="item.url" class="card" target="_blank">{{ item.title }} <img src="https://www.shareicon.net/download/2015/08/31/93909_external.ico" width="10px" /></a>
          </li>
        </ul>
      </div>

      <div v-else>
        <ul>
          <li :key="item.id" v-for="item in items">
            <router-link :to="'/'+item.id" class="card">{{ item.title }}</router-link>
          </li>
        </ul>
      </div>

      
    </div>
  </div>
</template>

<script>
import content from '@/content'

export default {
  name: 'MainView',
  data () {
    return {
      focused: content.entities[this.$route.params.focused]
    }
  },
  computed: {
    links: function () {
      let key = this.$route.params.focused
      let relevant = content.links.filter((link) => link.includes(key)).map((link) => link[link[0] === key ? 1 : 0])
      let details = relevant.filter((linkKey) => content.entities[linkKey] && content.entities[linkKey].type).map((linkKey) => {
        return Object.assign(content.entities[linkKey], {id: linkKey})
      })

      let grouped = details.reduce((grpd, item) => {
        (grpd[item.type] = grpd[item.type] || []).push(item)
        return grpd
      }, {})

      return grouped
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
  margin-left: 0;
}

h1, h2, h3 {
    color: rgb(65, 148, 62);
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
}
a {
  text-decoration: none;
  background: #0C7218;
  color:#F6EDD9;
  padding: 10px;
  /* color: black; */
  border-radius: 10px;
  display: block;
  margin-right: 10px;
  margin-bottom: 10px;
}
#overview {
    margin-top: 2em;
    line-height: 1.5;
    max-width: 50em;
    font-size: 1.2em;
}

.card-row {
  display: flex;
  flex-wrap:wrap;
}

.card {
  padding: 10px;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
}

.card:not(a) {
  padding: 0px;
}

a.card:hover {
  opacity: 0.8;
}

h3 {
  font-size: 1.3em;
  margin-top: 2em;
  margin-bottom: 10px;
  font-variant:small-caps;
  text-transform: lowercase;
  letter-spacing: 0.1ch;
}
</style>



// WEBPACK FOOTER //
// src/components/MainView.vue